import type { RouteLocationNormalized } from 'vue-router';
import type { VinceApp } from '../composables/usePermission';
import { Action } from './roles';

export type Primitive = string | number | boolean;

export enum ResourceType {
    WEBHOOK = 'webhook',
    ENVIRONMENT = 'environment',
    WORKFLOW = 'workflow',
    CONNECTION = 'connection',
    METADATA = 'metadata',
    VARIABLE = 'variable',
    USER = 'user',
    TENANT = 'tenant',
    GROUP = 'group',
    ROLE = 'role',
    DASHBOARD = 'dashboard',
    META = 'meta', // Custom Tables meta (config)
    DATA = 'data', // Custom Tables data (records)
    APICLIENT = 'apiclient', // API Clients,
    APP = 'app', // AI apps
    INDEXER = 'indexer', // Custom Tables indexer
}

export enum SortDirection {
    ASC = 'asc',
    DESC = 'desc'
}

export enum DataType {
    STRING = 'STRING',
    NUMERIC = 'NUMERIC',
    DATE = 'DATE',
    BOOLEAN = 'BOOLEAN',
    MESSAGE = 'MESSAGE'
}

export enum Comparison {
    equal = 'equal',
    notEqual = 'notEqual',
    lessThan = 'lessThan',
    lessThanInclusive = 'lessThanInclusive',
    greaterThan = 'greaterThan',
    greaterThanInclusive = 'greaterThanInclusive',
    isBlank = 'isBlank',
    isNotBlank = 'isNotBlank',
    stringContains = 'stringContains',
    stringNotContains = 'stringNotContains',
    contains = 'contains',
    notContains = 'notContains'
}

export interface ResourceItem {
    id: string,
    key: string,
    label: string,
    description?: string,
    resourceType?: string,
    usable?: boolean,
    labels?: string[]
}

export enum LogicalOperator {
    AND = 'AND',
    OR = 'OR'
}

export enum ENV_MAP {
    production = 'vince.live',
    staging = 'staging.vincelive.dev',
    default = 'dev.vincelive.dev'
}

export interface PageHeadConfig {
  titlePrefix?: string;
  excludedSegments?: string[];
  fallbackTitle?: string;
}
export type AuthorizationConfig = {
    resourceType: ResourceType;
    action: Action;
    resourceName: string;
    vinceApp?: VinceApp;
};

export type RouteAuthConfig = {
    resourceType: ResourceType;
    getAction: (route: RouteLocationNormalized) => Action;
    getResourceName?: (route: RouteLocationNormalized) => string;
    vinceApp?: VinceApp;
};

export interface ApiError {
    status: number;
    message: string;
    errorName?: string;
    errorMessage?: string;
    statusCode?: number;
}
